import * as React from 'react'

import { Input, Textarea } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { QuizBlock } from 'modules/trainings/lib/content/QuizBlock'

const QuizBlockEditor = observer(
  ({ contentItem: quiz, trainingId }: ContentEditorProps<QuizBlock>) => {
    const ensureFormExists = () => {
      if (!quiz.form) {
        quiz.form = {
          id: null,
          title: quiz.title,
          description: undefined,
          resourceId: String(trainingId),
          resourceType: 'Trainings::Training',
          formType: 'quiz',
          elements: [],
        }
      }
    }

    return (
      <>
        <Input
          label={i18n.t('trainings.content.block.quiz.title_label')}
          onChange={(value: string) => {
            ensureFormExists()
            quiz.title = value
            if (quiz.form) {
              quiz.form.title = value
            }
          }}
          placeholder={i18n.t('trainings.content.block.quiz.title_placeholder')}
          value={quiz.title}
          required
          size="md"
          maxLength={60}
        />
        <Textarea
          label={i18n.t('trainings.content.block.quiz.description_label')}
          onChange={(value: string) => {
            ensureFormExists()
            if (quiz.form) {
              quiz.form.description = value
            }
          }}
          placeholder={i18n.t('trainings.content.block.quiz.description_placeholder')}
          value={quiz.form?.description ?? undefined}
        />
      </>
    )
  }
)

export { QuizBlockEditor }
